<template>
    <div v-if="item.key === 'personal_tags'">
        <v-list-item
        v-for="(tag, index) in personalTagsAsMenus"
        :key="index"
        link
        data-testid="contacts-drawer-personaltagslist"
        :class="$vuetify.theme.dark ? 'custom-list-item-dark' : 'custom-list-item-light'"
        @click="onDrawerItemClick(tag)"
        >
        <v-list-item-icon v-if="tag.icon" class="mt-4">
          <v-badge
            color="grey"
            offset-x="7"
            offset-y="7"
            :content="personalTags[index].inUseCount == 0 ? '0' : personalTags[index].inUseCount"
          >
          <v-icon>{{ tag.icon }}</v-icon>
          </v-badge>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
          {{ tag.text }}
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <div>
            <v-btn
              icon
              class="edit_personal_tag_btn"
              @click="openTagForm({tag: personalTags[index], isPersonal: true, isUpdate: true})"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn
              icon
              class="delete_personal_tag_btn"
              @click="openTagDeleteForm({tag: personalTags[index]})"
            >
              <v-icon color="red">mdi-delete</v-icon>
            </v-btn>
          </div>
        </v-list-item-action>
        </v-list-item>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Tag from 'Store/class/contact/tag'
import PersonalTag from 'Store/class/contact/personal_tag'
export default {
  name: 'contacts-drawer',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      canContactsWrite: 'permissions/contactsWrite',
      canContactsManagePersonal: 'permissions/contactsManagePersonal',
      getIsPersonal: 'contacts/isPersonal',
      tags: 'contacts/tags/tags',
      personalTags: 'contacts/personalTags/personalTags',
      getFilterByTags: 'contacts/filterByTags',
      getFilterByPersonalTags: 'contacts/filterByPersonalTags'
    }),
    personalTagsAsMenus () {
      const menus = []
      if (this.personalTags) {
        this.personalTags.forEach(personalTag => {
          menus.push({ icon: 'mdi-label-outline', text: personalTag.name, id: personalTag.id, key: 'personal_tag_item' })
        })
      }
      return menus
    },
    filterByPersonal: { get () { return this.getIsPersonal }, set (isPersonal) { this.setIsPersonal(isPersonal) } },
    filterByTags: { get () { return this.getFilterByTags }, set (filterByTags) { this.setFilterByTags(filterByTags) } },
    filterByPersonalTags: { get () { return this.getFilterByPersonalTags }, set (filterByPersonalTags) { this.setFilterByPersonalTags(filterByPersonalTags) } }
  },
  methods: {
    ...mapActions({
      setIsPersonal: 'contacts/setIsPersonal',
      getContacts: 'contacts/get',
      getTags: 'contacts/tags/get',
      getPersonalTags: 'contacts/personalTags/get',
      openTagDialog: 'contacts/tagForm/open',
      openDeleteDialog: 'contacts/tagDeleteForm/open',
      setFilterByTags: 'contacts/setFilterByTags',
      setFilterByPersonalTags: 'contacts/setFilterByPersonalTags',
      openImportDialog: 'contacts/importForm/open'
    }),

    openTagForm (params) {
      const isPersonal = params.isPersonal
      const isUpdate = params.isUpdate
      let tag = null
      if (isUpdate) {
        tag = params.tag
      } else {
        tag = isPersonal ? new PersonalTag({ id: null, name: '' }) : new Tag({ id: null, name: '' })
      }
      this.openTagDialog({ tag, isPersonal, isUpdate })
    },

    openTagDeleteForm (params) {
      const tag = params.tag
      this.openDeleteDialog(tag)
    },

    onDrawerItemClick (item) {
      switch (item.key) {
        case 'personal_tag_item':
          this.filterByPersonal = true
          this.filterByTags = []
          this.filterByPersonalTags = [item.id]
          break
      }
    }
  }
}
</script>

<style>
.custom-list-item-dark {
  background-color: #424242;
}
.custom-list-item-light {
  background-color: #F5F5F5;
}
</style>
